export const systemInfo = (obj) => ({
    type: "SYSTEM",
    payload: obj
});